module.exports = __webpack_public_path__ + "img/CMerchantTransport64_ua.b1ad23b6.webp";